export const PATH_VARIABLES = {
  caseId: ':caseId',
  claimId: ':claimId',
  exportId: ':exportId',
};

const PUBLIC = {
  // NO LAYOUT
  pageNotFound: '/404',
  login: '/login',
  forgotPassword: '/forgot-password',
  passwordReset: '/password-reset',
  auth: '/__auth',
  accountActivation: '/account-activation',
  terms: '/terms',
  privacyPolicy: '/privacy',
  invalidLinkInvitation: '/invalid',
};

export const PRODUCT_BASE = {
  claimscore: '/claimscore',
  classresolution: '/classresolution',
  deepvalidation: '/deepvalidation',
};

const PRIVATE_BASE = {
  // TOP NAVBAR WITH CONTROLS ONLY
  root: '/',
  dashboard: '/dashboard',
  permissions: '/permissions/:tab?',
  security: '/security',
  scheduledReports: `${PRODUCT_BASE.claimscore}/reports`,
  caseSetup: '/case-setup',
  claimscoreSettings: `${PRODUCT_BASE.claimscore}/settings`,
  newCaseCreation: '/case-creation',
  uploadClaimsFile: '/upload-claims-file',
  claimFiles: `${PRODUCT_BASE.claimscore}/files`,
  developerTools: '/developer-tools/:tab?',
  classResolution: PRODUCT_BASE.classresolution,
  deepValidation: PRODUCT_BASE.deepvalidation,
  claimsExport: `/exports/${PATH_VARIABLES.exportId}`,
};

// Pre-CX-2189 URLs, kept only so bookmarks and shared links redirect.
const LEGACY = {
  scheduledReports: '/scheduled-reports',
  claimscoreSettings: '/claimscore-settings',
  claimFiles: '/files',
};

export const PATHS = {
  PUBLIC,
  PRIVATE_BASE,
  LEGACY,
};
